/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Výrobce`
};

const da_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Constructeur`
};

const de_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Motorrad-Marke`
};

const en_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Motorcycle brand`
};

const es_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Marca de motos`
};

const fr_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Constructeur`
};

const hu_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Constructeur`
};

const it_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Marchio di motociclette`
};

const nl_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Merk motorfiets`
};

const pl_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Constructeur`
};

const pt_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Marca de motocicleta`
};

const sv_attributes_motorcycle_brand = /** @type {(inputs: {}) => string} */ () => {
	return `Constructeur`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_motorcycle_brand = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_motorcycle_brand(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_motorcycle_brand", locale)
	if (locale === "cs") return cs_attributes_motorcycle_brand(inputs)
	if (locale === "da") return da_attributes_motorcycle_brand(inputs)
	if (locale === "de") return de_attributes_motorcycle_brand(inputs)
	if (locale === "en") return en_attributes_motorcycle_brand(inputs)
	if (locale === "es") return es_attributes_motorcycle_brand(inputs)
	if (locale === "fr") return fr_attributes_motorcycle_brand(inputs)
	if (locale === "hu") return hu_attributes_motorcycle_brand(inputs)
	if (locale === "it") return it_attributes_motorcycle_brand(inputs)
	if (locale === "nl") return nl_attributes_motorcycle_brand(inputs)
	if (locale === "pl") return pl_attributes_motorcycle_brand(inputs)
	if (locale === "pt") return pt_attributes_motorcycle_brand(inputs)
	return sv_attributes_motorcycle_brand(inputs)
};
export { attributes_motorcycle_brand as "attributes.motorcycle_brand" }